import * as React from 'react';
import { connect } from "react-redux";
import { Link, Redirect } from 'react-router-dom';
import * as QueryString from "query-string";
import { Button, Card, Col, Form, Row, Table, Tab, Tabs } from "react-bootstrap";

//lib
import Swal from 'sweetalert2';
import { readJsonResponse } from '../../modules/common';
import * as _moment from "moment-timezone";

//component
import MonitorTable from './MonitorTable'

//models
import * as MonitorModels from '../../models/MonitorModels'

class VMbackupTap extends React.Component<any, { checkRequest: boolean, dataResult: Array<MonitorModels.MonitorList>, monitor_id: any, from: string, to: string }>{
    constructor(props: any) {
        super(props);
        this.state = {
            checkRequest: false,
            dataResult: [],
            monitor_id: '',
            from: '',
            to: ''
        }
    }

    componentDidMount() {

        if (this.props.monitor_id != undefined) {
            this.bindingData();
            this.setState({
                monitor_id: this.props.monitor_id
            })
        }
    }

    componentDidUpdate(nextProps: any, nextState: any) {

        if (this.props.monitor_id != this.state.monitor_id
            || this.props.from != this.state.from
            || this.props.to != this.state.to) {
            this.bindingData();
            this.setState({
                monitor_id: this.props.monitor_id,
                from: this.props.from,
                to: this.props.to
            })
        }
    }

    bindingData() {
        var ls: any = localStorage.getItem("DB_BACKUP_APPLICATION");
        this.setState({
            dataResult: [],
            checkRequest: false
        })
        fetch("v1/google?monitor_id=" + this.props.monitor_id + "&date_time_from=" + this.props.from + "&date_time_to=" + this.props.to,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + ls
                }
            }
        )
            .then(readJsonResponse)
            .then((result) => {
                console.log(result);
                var dataCount = result.totalCount
                var dataResult: Array<MonitorModels.MonitorList> = []
                if (dataCount > 0) {
                    result.resultList.sort((a, b) => (a.createdOn < b.createdOn) ? 1 : ((b.createdOn < a.createdOn) ? -1 : 0))
                    for (var i = 0; i < result.resultList.length; i++) {
                        var data_: MonitorModels.MonitorList = {
                            name: (result.resultList[i].name != null || result.resultList[i].name != undefined ? result.resultList[i].name : ''),
                            type: '',
                            size: (result.resultList[i].contentLength != null || result.resultList[i].contentLength != undefined ? (result.resultList[i].contentLength).toLocaleString(undefined, { minimumFractionDigits: 0 }) : ''),
                            backup_time: (result.resultList[i].createdOn != null || result.resultList[i].createdOn != undefined ? (_moment(result.resultList[i].createdOn).tz('Asia/Bangkok').format('MMM DD YYYY h:mm:ss A')) : ''),
                            finish_time: '',
                            duration_time: '',
                            ratio: ''
                        }
                        dataResult.push(data_)
                    }
                }

                console.log(dataResult)
                this.props.get_data(dataResult)
                this.setState({
                    dataResult: dataResult,
                    checkRequest: true
                })
            },
                (error) => {
                    if (error && error.redirecting) {
                        return;
                    }

                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        text: (error && error.apiMessage) || 'ไม่สามารถเชื่อมต่อกับ server ได้ในขณะนี้',
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'ยืนยัน',
                    })

                    this.props.get_data([])
                    this.setState({
                        dataResult: [],
                        checkRequest: true
                    })
                }
            )
    }

    render() {
        return (
            <div>
                {/*<div className="master-data-content">*/}
                {/*    <div className='trapezoid-head' style={{ width: '200px' }}>*/}
                {/*        <span>*/}
                {/*            VM Back up*/}
                {/*        </span>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="mat-box">
                    <Row>
                        <Col>
                            <MonitorTable checkRequest={this.state.checkRequest} dataResult={this.state.dataResult} />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
} export default VMbackupTap;